import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useNavigate, useLocation } from "react-router-dom";
import { getFormatedNumber, getFieldData } from "../../services/appService";
import AddEditDuration from "../../components/OMCRegistry/AddEditDuration";
import ViewCandidate from "../../components/OMCRegistry/ViewCandidate";
import { getAddedDurationObj } from "../store/duration";
import { useDispatch, useSelector } from "react-redux";
import AddEditRates from "../../components/OMCRegistry/AddEditRates";
import { getAddedRateObj } from "../store/rates";
import {
  filterRecruiterClear,
  getFilterAllRecruiters,
  getFilterAllRecruiters2,
  getRecCurrentWfTask,
  getRecruiterBprmForm,
  loadRecruiterBprmForm,
  loadRecruitersByFilter,
  loadRecruitersByFilter2,
  loadRecruiterWfTask,
  recCurrentWfTaskReceived,
  receivedRecruiterById,
  recruiterBprmFormReceived,
} from "../store/recruiter";
import {
  filterSubcontractorsClear,
  getFilterAllSubcontractors,
  getFilterAllSubcontractors2,
  getSubcontractorBprmForm,
  getSubsCurrentWfTask,
  loadSubcontractorBprmForm,
  loadSubcontractorsByFilter,
  loadSubcontractorsByFilter2,
  loadSubcontractorWfTask,
  receivedSubcontractorById,
  subcontractorBprmFormReceived,
  subsCurrentWfTaskReceived,
} from "../store/subcontractor";
import Document from "../../components/PortalForms/Document";
import config from "../../config.json";
import {
  candidateBprmFormReceived,
  getCandidateApps,
  getCandidateBprmForm,
  loadCandidateApps,
  loadCandidateBprmForm,
  receivedCandidateById,
} from "../store/candidate";
import WorkflowElement from "./WorkflowElement";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import AchInformation from "../../ReviewTools/AchInformation";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";
import { formLibraryReceived } from "../store/forms";
import {
  documentReceived,
  esignDocumentsReceived,
  reqDocumentReceived,
} from "../store/documents";
import RateEncryptDecrypt from "../../services/RateEncryptDecrypt";
import { Modal } from "react-bootstrap";

export default function CandidateInfo(props) {
  const { candidate, type, currentTask, app, listType, candidateListState } =
    props;
  const navigate = useNavigate();
  const location = useLocation();
  const handleSectionHideShow =
    props.handleSectionHideShow || props.handleshowtable || (() => {});

  const [showSummaryGrid, setShowSummaryGrid] = useState(false);
  const [durationShowHide, setDurationShowHide] = useState(false);
  const [regShowHide, setRegShowHide] = useState(false);
  const [viewShowHide, setViewShowHide] = useState(false);
  const [editDurType, setEditDurType] = useState("");
  const [viewType, setViewType] = useState("");
  const [item, setItem] = useState("");
  const [selectedKey, setSelectedKey] = useState(-1);
  const [selectedInfo, setSelectedInfo] = useState("");
  const [wfflowtask, setWfflowtask] = useState("");
  const [infoItem, setInfoItem] = useState("");
  const [infoApp, setInfoApp] = useState("");
  const [SelectedFormKey, setSelectedFormKey] = useState(-1);
  const [wfTask, setWfTask] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [entityType, setEntityType] = useState(null);
  const [w2Type, setW2type] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [viewFormType, setViewFormType] = useState("");
  const [selectedCurrentTask, setSelectedCurrentTask] = useState("");
  const [selectedApp, setSelectedApp] = useState("");
  const [fetchedDataType, setFetchedDataType] = useState("");
  const [appDocuments, setAppDocuments] = useState([]);
  const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);
  const [achType, setAchType] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [purchaseShowHide, setPurchaseShowHide] = useState(false);
  const [poOrderType, setPoOrderType] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [contractDocType, setContractDocType] = useState("");
  const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
  const [partnerAppData, setPartnerAppData] = useState(null);

  const addedDurationObjSelector = useSelector(getAddedDurationObj);
  const addedRateObjSelector = useSelector(getAddedRateObj);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
  const filterAllRecruiters = useSelector(getFilterAllRecruiters);

  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm);
  const filterAllSubcontractors2 = useSelector(getFilterAllSubcontractors2);
  const filterAllRecruiters2 = useSelector(getFilterAllRecruiters2);
  const candidateAppsSelector = useSelector(getCandidateApps);

  const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
  const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);

  const dispatch = useDispatch();

  useEffect(() => {
    if (candidate) setItem(candidate);
    if (currentTask) setSelectedCurrentTask(currentTask);
  }, [candidate, currentTask]);

  const handleDurationShowHide = (obj, type, key) => {
    closeACHInsu();
    setSelectedCurrentTask("");
    setWfForm(null);
    setEditDurType("");
    setSelectedApp(null);

    if (key === -1) {
      handleSectionHideShow(false);
    }

    if (type === "save") {
      setEditDurType("");
      handleSectionHideShow(false);
    } else {
      setEditDurType(type);
      handleSectionHideShow(true);
    }
    setViewType("");

    if (viewType === type) {
      setViewShowHide(false);
      handleSectionHideShow(false);
      setViewType("");
    }
  };

  useEffect(() => {
    if (addedDurationObjSelector) {
      const objItem = { ...item };
      objItem.duration = addedDurationObjSelector;
      setItem(objItem);
    }
  }, [addedDurationObjSelector]);

  useEffect(() => {
    setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector]);

  useEffect(() => {
    setWfForm(recruiterBprmFormSelector);
  }, [recruiterBprmFormSelector]);

  useEffect(() => {
    if (addedRateObjSelector) {
      const objItem = { ...item };
      objItem.rates = addedRateObjSelector;
      setItem(objItem);
    }
  }, [addedRateObjSelector]);

  const handleDurationChanges = (newObj) => {
    setEditDurType("");
    setDurationShowHide(false);
    setViewType("");
  };

  const handlViewRegistration = () => {
    setRegShowHide(!regShowHide);
    //setSelectedObj(item);
  };

  const handleViewShowHide = (view) => {
    console.log(view);
    if (viewType === view) return;
    setSelectedCurrentTask("");
    setWfForm(null);
    setEditDurType("");
    setSelectedApp(null);
    setEditDurType("");
    setViewFormType("");
    // if (viewType === view) {
    //     setViewShowHide(false);
    //     handleSectionHideShow(false)
    //     setViewType("");
    // } else {
    //     setViewType(view);
    //     setViewShowHide(true);
    //     handleSectionHideShow(true)
    // }
    setViewType(view);
    setViewShowHide(true);
    handleSectionHideShow(true);
  };

  const handleDocumentViewShowHide = (type, item) => {
    if (editDurType === type) return;
    closeACHInsu();
    setSelectedFormKey(-1);
    setEditDurType(type);
    setViewShowHide(false);
    setFetchedDataType("Document");
    handleSectionHideShow(true);
    const tsk = app?.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    // if (type === "Candidate" || type === "agency" || type === "msp") {
    //     const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    //     setSelectedCurrentTask(tsk);
    // }
    // else {
    //     setSelectedCurrentTask(null);
    // }
  };

  const handleCloseDocumentView = () => {
    console.log("candidateinfo");
    setFetchedDataType("");
    setSelectedKey(-1);
    setSelectedCurrentTask(null);
    setEditDurType("");
    handleSectionHideShow(false);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
  };

  const handleViewcandidateForm = (type, key, item) => {
    if (viewFormType === type) return;

    setSelectedKey(-1);
    setViewFormType(type);
    setFetchedDataType("Form");
    setSelectedFormKey(key);
    setCandidateObj(item);
    handleSectionHideShow(true);
    if (type === "Candidate") {
      const entType = getFieldData(
        item.performerData,
        "candidateonboardingform",
        "CandidateEntity",
      );
      const w9type = getFieldData(
        item.performerData,
        "candidateonboardingform",
        "w9_Type",
      );
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
    } else if (type === "Subcontractor") {
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
      dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid));
    } else if (type === "Recruiter") {
      dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
      dispatch(loadRecruiterWfTask(item?.recruiter?.parentid));
    }
  };

  useEffect(() => {
    if (subsCurrentWfTaskSelector) {
      setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
      setWfTask({
        formId: config.formIds.subcontractor,
        ciid: subsCurrentWfTaskSelector.ciid,
      });
      setPartnerAppData(subsCurrentWfTaskSelector.appData);
    }
  }, [subsCurrentWfTaskSelector]);

  useEffect(() => {
    if (recCurrentWfTaskSelector) {
      setPartnerCurrentWfTask(recCurrentWfTaskSelector);
      setWfTask({
        formId: config.formIds.recruiter,
        ciid: recCurrentWfTaskSelector.ciid,
      });
      setPartnerAppData(recCurrentWfTaskSelector.appData);
    }
  }, [recCurrentWfTaskSelector]);

  const setCandidateType = (entType) => {
    let appCiid = 0;
    if (candidateObj?.applications?.length > 0) {
      const allWfTasks = candidateObj?.applications[0].workflowTasks;
      if (allWfTasks?.length > 0) {
        appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      }
    }

    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis));
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({
        formId: config.formIds.candidate.Ten_99_Basis,
        ciid: appCiid,
      });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis));
    }
  };

  useEffect(() => {
    if (candidateObj) {
      if (candidateObj.applications?.length > 0) {
        setUpdatedStateData(candidateObj.applications[0].applicationData);
      } else {
        setUpdatedStateData(candidateObj.performerData);
      }
    } else {
      setUpdatedStateData(null);
    }
  }, [candidateObj]);

  useEffect(() => {
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector]);

  const getLastWorkflowTask = (workflowTasks) => {
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0,
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const closeACHInsu = () => {
    setSelectedInfo("");
    setAchType("");
    setInsuranceType("");
    setContractDocType("");
    handleSectionHideShow(false);
  };

  const handleACHShowHide = (mod, type, item, key, app) => {
    console.log("candidateinfo");
    if (achType == type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setFetchedDataType("");
    setEditDurType("");
    setAchType(type);
    setInsuranceType("");
    setContractDocType("");
    handleSectionHideShow(true);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  };

  const handleInsuranceShowHide = (mod, type, item, key, app) => {
    console.log("candidateinfo");
    if (insuranceType == type) return;
    dispatch(formLibraryReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
    setSelectedInfo(mod);
    setFetchedDataType("");
    setEditDurType("");
    setAchType("");
    setInsuranceType(type);
    setContractDocType("");
    handleSectionHideShow(true);
    const tsk = app.workflowTasks[app.workflowTasks.length - 1];
    setSelectedCurrentTask(tsk);
    setSelectedApp(app);
  };

  const handleNextTask = () => {
    console.log("");
  };
  const getOnboardingField = (fieldName) => {
    return getFieldData(
      item?.performerData,
      "candidateonboardingform",
      fieldName,
    );
  };

  const getProjectField = (fieldName) => {
    return getFieldData(item?.performerData, "projectengagement", fieldName);
  };

  const getProjectValue = (fields) => {
    return fields
      .map((field) => getProjectField(field))
      .find((value) => value && value !== "");
  };

  const getSubcontractorPhone = () => {
    return getFieldData(
      item?.performerData,
      "subcontractorenrollmentform",
      "Company_Phone",
    );
  };

  const getRecruiterPhone = () => {
    return getFieldData(
      item?.performerData,
      "recruiterenrollmentform",
      "Company_Phone",
    );
  };

  const formatUSPhoneNumber = (phoneNo) => {
    if (!phoneNo) return "";
    const cleaned = ("" + phoneNo).replace(/\D/g, "");
    const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[2]}) ${match[3]}-${match[4]}`;
    }
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return phoneNo;
  };

  const getAddress = (target) => {
    if (!target) return null;
    const perfData = target.performerData;
    let line1 = "";
    let line2 = "";
    let city = "";
    let state = "";
    let zip = "";

    if (
      perfData &&
      typeof perfData === "string" &&
      perfData.includes("candidateonboardingform")
    ) {
      try {
        line1 =
          getFieldData(
            perfData,
            "candidateonboardingform",
            "Current_Address_Line1",
          ) || "";
        line2 =
          getFieldData(
            perfData,
            "candidateonboardingform",
            "Current_Address_Line2",
          ) || "";
        city =
          getFieldData(perfData, "candidateonboardingform", "Current_City") ||
          "";
        state =
          getFieldData(perfData, "candidateonboardingform", "Current_State") ||
          "";
        zip =
          getFieldData(
            perfData,
            "candidateonboardingform",
            "Current_Zip_Code",
          ) || "";
      } catch (e) {
        console.error("Error parsing performerData: ", e);
      }
    }

    if (!line1 && !city && !state) {
      line1 =
        target.Address_Line1 ||
        target.address_Line1 ||
        target.address_line1 ||
        target.addressLine1 ||
        "";
      line2 =
        target.Address_Line2 ||
        target.address_Line2 ||
        target.address_line2 ||
        target.addressLine2 ||
        "";
      city =
        target.US_City || target.us_City || target.us_city || target.city || "";
      state =
        target.US_State ||
        target.us_State ||
        target.us_state ||
        target.state ||
        "";
      zip =
        target.Zip_Code ||
        target.zip_Code ||
        target.zip_code ||
        target.zipCode ||
        target.zip ||
        "";
    }

    if (!line1 && !city && !state) return null;

    return { line1, line2, city, state, zip };
  };

  const getAdminAgencyFee = (targetItem) => {
    const activeItem = targetItem || item;
    const feePer = getFieldData(
      activeItem?.performerData,
      "projectengagement",
      "State_Admin_Fee",
    );

    const feeDo = getFieldData(
      activeItem?.performerData,
      "projectengagement",
      "State_Admin_Fee_Amount",
    );

    if (
      feePer !== "" &&
      feePer !== "0" &&
      feePer !== undefined &&
      feePer !== null
    ) {
      return (
        <>
          State Admin Fee :{" "}
          <RateEncryptDecrypt rateData={feePer} startSymbol="" endSymbol="%" />
        </>
      );
    } else if (
      feeDo !== "" &&
      feeDo !== "0" &&
      feeDo !== undefined &&
      feeDo !== null
    ) {
      return (
        <>
          State Admin Fee : <RateEncryptDecrypt rateData={feeDo} />
        </>
      );
    }

    return null;
  };

  const handlePurchaseShowHide = (item, type, poType) => {
    setPurchaseShowHide(!purchaseShowHide);
    setCandidateObj(item);
    setPoOrderType(type);
    setSelectedItem({ partnerType: poType });
    if (item?.applications?.length > 0) {
      const tsk =
        item.applications[0].workflowTasks[
          item.applications[0].workflowTasks.length - 1
        ];
      setSelectedCurrentTask(tsk);
    }
  };

  const handleSignUnsignPo = (unSignPo) => {
    //setPoCount(unSignPo);
  };

  const handleRefreshPoOrders = () => {
    // if (item?.partnerId)
    //   dispatch(loadPartnerPerformers(item.partnerId));
  };

  const handleDurationAndRateShowHide = (obj, type, key) => {
    console.log(type);
    closeACHInsu();
    setSelectedFormKey(-1);
    setFetchedDataType("ViewForm");
    setViewFormType("");
    setViewType("");
    if (fetchedDataType !== "ViewForm") {
      setEditDurType("");
      setSelectedKey(-1);
    }
    // if (type === "save") {
    //     if (dataType === "filter") handleFilter();
    //     else dispatch(loadCandidates(pageSize, currentPage, applicantType))
    // }
    //setSelectedObj(item);
    setViewShowHide(false);
    if (editDurType === type) {
      setEditDurType("");
      setSelectedKey(-1);
    } else {
      setEditDurType(type);
      setSelectedKey(key);
      if (type === "") handleSectionHideShow(false);
      else handleSectionHideShow(true);
    }

    // handleViewShowHide(obj, type, key)
  };

  const handleCloseViewForm = () => {
    setViewFormType("");
    setFetchedDataType("");
    setSelectedFormKey(-1);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEntityType("");
    setW2type(null);
    dispatch(candidateBprmFormReceived(null));
    dispatch(subcontractorBprmFormReceived(null));
    dispatch(recruiterBprmFormReceived(null));
    setPartnerCurrentWfTask(null);
    handleSectionHideShow(false);
  };

  const reviewSubject = item?.performername
    ? [item.performername, item.lastName].filter(Boolean).join(" ")
    : "";

  const candidateAddress = getAddress(item);

  const heroInitials = (reviewSubject || "RR")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  const summaryHeaderEmail = item?.performeremail || item?.email || "";
  const summaryHeaderPhone = item?.contactNo || item?.phone || "";
  const displayAppName = app?.applicationType || "Onboarding Application";
  const displayCiid = app?.ciid || "N/A";
  const onboardingStatus = app?.appSubmitted ? "Complete" : "Review";

  const formatTitleName = (name) => {
    if (!name) return "";
    if (name.toLowerCase() === "msp") return "MSP";
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  const getPopupTitle = () => {
    if (purchaseShowHide) {
      return "Purchase Orders";
    }
    if (editDurType !== "" && fetchedDataType === "Document") {
      return `${formatTitleName(editDurType)} Documents`;
    }
    if (selectedInfo === "ACH") {
      return `${formatTitleName(achType)} ACH Information`;
    }
    if (selectedInfo === "Insurance") {
      return `${formatTitleName(insuranceType)} Insurance Information`;
    }
    if (viewType !== "" && viewShowHide) {
      if (viewType === "agency") return "Agency Details";
      if (viewType === "msp") return "MSP Details";
      return `${formatTitleName(viewType)} Details`;
    }
    if (wfForm && SelectedFormKey === 0) {
      return `${formatTitleName(viewFormType)} Details`;
    }
    if (editDurType === "duration") {
      return "Duration Details";
    }
    if (editDurType === "rate") {
      return "Rate Details";
    }
    return "Summary Details";
  };

  const getPopupIcon = () => {
    if (purchaseShowHide) {
      return "fa-shopping-cart";
    }
    if (editDurType !== "" && fetchedDataType === "Document") {
      return "fa-id-card-o";
    }
    if (selectedInfo === "ACH") {
      return "fa-bank";
    }
    if (selectedInfo === "Insurance") {
      return "fa-shield";
    }
    if (viewType !== "" && viewShowHide) {
      return "fa-user";
    }
    if (wfForm && SelectedFormKey === 0) {
      return "fa-pencil-square-o";
    }
    if (editDurType === "duration") {
      return "fa-clock-o";
    }
    if (editDurType === "rate") {
      return "fa-dollar";
    }
    return "fa-info-circle";
  };

  const handleClosePopup = () => {
    setPurchaseShowHide(false);
    setFetchedDataType("");
    setSelectedKey(-1);
    setSelectedCurrentTask(null);
    setSelectedInfo("");
    setAchType("");
    setInsuranceType("");
    setContractDocType("");
    setViewType("");
    setViewShowHide(false);
    setViewFormType("");
    setSelectedFormKey(-1);
    setWfTask(null);
    setWfId(0);
    setCandidateObj(null);
    setEntityType("");
    setW2type(null);
    setEditDurType("");
    handleSectionHideShow(false);
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(candidateBprmFormReceived(null));
    dispatch(subcontractorBprmFormReceived(null));
    dispatch(recruiterBprmFormReceived(null));
    setPartnerCurrentWfTask(null);
  };

  const isPopupOpen = !!(
    purchaseShowHide ||
    (editDurType !== "" && fetchedDataType === "Document") ||
    selectedInfo === "ACH" ||
    selectedInfo === "Insurance" ||
    (viewType !== "" && viewShowHide) ||
    (wfForm && SelectedFormKey === 0) ||
    editDurType === "duration" ||
    editDurType === "rate"
  );

  return (
    <React.Fragment>
      <style>{`
                @keyframes rtFadeIn {
                  from { opacity: 0; transform: translateY(8px); }
                  to { opacity: 1; transform: translateY(0); }
                }

                @keyframes rtSlideDown {
                  from {
                    opacity: 0;
                    transform: translateY(-8px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }

                .rt-page {
                  animation: rtFadeIn 0.28s ease both;
                  --c-bg: #ffffff;
                  --c-surface: #f8fafc;
                  --c-canvas: #f3f6fb;
                  --c-border: #e2e8f0;
                  --c-border-light: #f1f5f9;
                  --c-text: #0f172a;
                  --c-text-2: #475569;
                  --c-text-3: #94a3b8;

                  --c-indigo: #2563eb;
                  --c-indigo-h: #1d4ed8;
                  --c-indigo-s: #eff6ff;
                  --c-indigo-m: #bfdbfe;

                  --c-green: #16a34a;
                  --c-green-s: #f0fdf4;

                  --c-amber: #d97706;
                  --c-amber-s: #fffbeb;

                  --c-rose: #e11d48;
                  --c-rose-s: #fff1f2;

                  --c-sky: #0284c7;
                  --c-sky-s: #f0f9ff;

                  --c-violet: #6d28d9;
                  --c-violet-s: #f5f3ff;
                }

                                .rt-shell {
                  border: 1px solid rgba(226,232,240,0.88) !important;
                  border-radius: 18px !important;
                  background: #ffffff !important;
                  box-shadow: 0 10px 30px -15px rgba(15,23,42,0.15) !important;
                  overflow: hidden !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                }

                .rt-hero {
                  display: grid !important;
                  grid-template-columns: 1fr auto !important;
                  align-items: stretch !important;
                  gap: 20px !important;
                  padding: 20px !important;
                  background: linear-gradient(135deg, rgba(239,246,255,0.9) 0%, #ffffff 46%, #f8fafc 100%) !important;
                  border-bottom: 1px solid var(--c-border-light) !important;
                  position: relative !important;
                  overflow: hidden !important;
                }

                .rt-hero::before {
                  content: "" !important;
                  position: absolute !important;
                  inset: 0 0 auto 0 !important;
                  height: 3px !important;
                  background: linear-gradient(90deg, #2563eb, #10b981, #eab308) !important;
                }

                .rt-hero-left {
                  display: flex !important;
                  gap: 16px !important;
                  align-items: flex-start !important;
                  min-width: 260px !important;
                  flex: 1 1 360px !important;
                  position: relative !important;
                  z-index: 1 !important;
                }

                .rt-hero-main {
                  flex: 1 !important;
                  min-width: 0 !important;
                }

                .rt-hero-icon {
                  width: 52px !important;
                  height: 52px !important;
                  border-radius: 14px !important;
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  color: #1d4ed8 !important;
                  background: #ffffff !important;
                  border: 1px solid #bfdbfe !important;
                  font-size: 15px !important;
                  font-weight: 900 !important;
                  letter-spacing: 0.03em !important;
                  flex-shrink: 0 !important;
                  box-shadow: 0 10px 24px rgba(37,99,235,0.12) !important;
                  position: relative !important;
                }

                .rt-hero-icon-badge {
                  position: absolute !important;
                  right: -5px !important;
                  bottom: -5px !important;
                  width: 20px !important;
                  height: 20px !important;
                  border-radius: 50% !important;
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  background: #2563eb !important;
                  color: #ffffff !important;
                  border: 2px solid #ffffff !important;
                  font-size: 9px !important;
                  box-shadow: 0 4px 8px rgba(37,99,235,0.2) !important;
                }

                .rt-kicker {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  margin: 0 0 8px !important;
                  color: #1d4ed8 !important;
                  font-size: 10px !important;
                  font-weight: 800 !important;
                  letter-spacing: 0.08em !important;
                  text-transform: uppercase !important;
                  background: #eff6ff !important;
                  border: 1px solid #bfdbfe !important;
                  border-radius: 999px !important;
                  padding: 4px 9px !important;
                }

                .rt-title {
                  font-size: 20px !important;
                  font-weight: 900 !important;
                  color: var(--c-text) !important;
                  margin: 0 !important;
                  line-height: 1.15 !important;
                  letter-spacing: 0 !important;
                }

                .rt-subtitle {
                  font-size: 11px !important;
                  color: #64748b !important;
                  margin: 7px 0 0 !important;
                  max-width: 620px !important;
                  line-height: 1.45 !important;
                }

                .rt-hero-highlights {
                  display: flex !important;
                  align-items: center !important;
                  gap: 8px !important;
                  flex-wrap: wrap !important;
                  margin-top: 12px !important;
                }

                .rt-hero-highlight {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 7px !important;
                  padding: 7px 10px !important;
                  border-radius: 8px !important;
                  background: rgba(255,255,255,0.82) !important;
                  border: 1px solid #e2e8f0 !important;
                  color: #334155 !important;
                  font-size: 10px !important;
                  font-weight: 800 !important;
                  box-shadow: 0 2px 6px rgba(15,23,42,0.03) !important;
                }

                .rt-hero-highlight i {
                  color: #2563eb !important;
                  font-size: 11px !important;
                }

                .rt-actions {
                  display: flex !important;
                  flex-direction: column !important;
                  align-items: flex-end !important;
                  gap: 12px !important;
                  min-width: 320px !important;
                  position: relative !important;
                  z-index: 1 !important;
                }

                .rt-app-card {
                  display: flex !important;
                  align-items: center !important;
                  gap: 16px !important;
                  padding: 16px 20px !important;
                  background: #ffffff !important;
                  border: 1px solid #e2e8f0 !important;
                  border-radius: 16px !important;
                  width: 100% !important;
                  max-width: 380px !important;
                  transition: all 0.2s ease-in-out !important;
                  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03) !important;
                }

                .rt-app-card:hover {
                  background: #f8fafc !important;
                  border-color: #cbd5e1 !important;
                  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06) !important;
                }

                .rt-app-card-left {
                  display: flex !important;
                  align-items: center !important;
                  gap: 16px !important;
                  min-width: 0 !important;
                  flex: 1 !important;
                }

                .rt-app-card-icon {
                  width: 48px !important;
                  height: 48px !important;
                  border-radius: 12px !important;
                  background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%) !important;
                  display: flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  color: #ffffff !important;
                  font-size: 20px !important;
                  flex-shrink: 0 !important;
                  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.15) !important;
                }

                .rt-app-card-info {
                  display: flex !important;
                  flex-direction: column !important;
                  min-width: 0 !important;
                }

                .rt-app-card-label {
                  font-size: 10px !important;
                  font-weight: 700 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.06em !important;
                  color: #64748b !important;
                  margin-bottom: 4px !important;
                }

                .rt-app-card-title {
                  font-size: 15px !important;
                  font-weight: 850 !important;
                  color: #0f172a !important;
                  margin: 0 0 4px 0 !important;
                  word-break: break-word !important;
                }

                .rt-app-card-meta {
                  display: flex !important;
                  align-items: center !important;
                  gap: 16px !important;
                  font-size: 13px !important;
                  color: #475569 !important;
                  font-weight: 600 !important;
                }

                .rt-app-card-ciid {
                  color: #475569 !important;
                  font-weight: 600 !important;
                }

                .rt-app-card-status {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 4px !important;
                  color: #0f172a !important;
                }

                .rt-pill {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  padding: 4px 10px !important;
                  border-radius: 99px !important;
                  font-size: 11px !important;
                  font-weight: 700 !important;
                  white-space: nowrap !important;
                  transition: all 0.15s ease !important;
                  border: 1px solid #e2e8f0 !important;
                  background: #ffffff !important;
                  color: #475569 !important;
                }
                .rt-pill i {
                  font-size: 11px !important;
                }
                .rt-pill.success {
                  background: #ecfdf5 !important;
                  border-color: #a7f3d0 !important;
                  color: #065f46 !important;
                }
                .rt-pill.success i {
                  color: #10b981 !important;
                }
                .rt-pill.warning {
                  background: #fffbeb !important;
                  border-color: #fde68a !important;
                  color: #b45309 !important;
                }
                .rt-pill.warning i {
                  color: #f59e0b !important;
                }

                .rt-panel {
                  --task-accent: #64748b;
                  --task-soft: #f8fafc;
                  border: 1px solid #e2e8f0 !important;
                  border-radius: 10px !important;
                  background: #ffffff !important;
                  box-shadow: 0 4px 14px rgba(15,23,42,0.04) !important;
                  overflow: hidden !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                }
                .rt-panel + .rt-panel { margin-top: 16px !important; }

                .rt-panel.btn-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }

                .rt-panel-header {
                  display: flex !important;
                  align-items: center !important;
                  justify-content: space-between !important;
                  gap: 16px !important;
                  padding: 14px 16px !important;
                  background: linear-gradient(90deg, var(--task-soft), #ffffff 56%) !important;
                  border-bottom: 1px solid #edf2f7 !important;
                  border-left: 4px solid var(--task-accent) !important;
                }
                .rt-panel-title {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 12px !important;
                  margin: 0 !important;
                  color: #0f172a !important;
                  font-size: 15px !important;
                  font-weight: 850 !important;
                  line-height: 1.25 !important;
                }
                .rt-panel-title i {
                  width: 38px !important;
                  height: 38px !important;
                  border-radius: 10px !important;
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  flex-shrink: 0 !important;
                  color: var(--task-accent) !important;
                  background: #ffffff !important;
                  border: 1px solid var(--task-accent) !important;
                  box-shadow: 0 2px 8px rgba(15,23,42,0.05) !important;
                  font-size: 14px !important;
                }
                .rt-panel-title-badge {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  gap: 5px !important;
                  padding: 5px 9px !important;
                  border-radius: 999px !important;
                  font-size: 10px !important;
                  font-weight: 800 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.02em !important;
                  background: var(--task-soft) !important;
                  color: var(--task-accent) !important;
                  border: 1px solid #e2e8f0 !important;
                  font-style: normal !important;
                }
                .rt-panel-header .rt-action-btn {
                  min-height: auto !important;
                  padding: 7px 10px !important;
                  font-size: 11px !important;
                  font-weight: 800 !important;
                  border-radius: 8px !important;
                  gap: 5px !important;
                  white-space: nowrap !important;
                }

                .rt-action-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  gap: 5px !important;
                  border-radius: 8px !important;
                  border: 1px solid #cbd5e1 !important;
                  background: #ffffff !important;
                  color: #475569 !important;
                  padding: 7px 10px !important;
                  font-size: 11px !important;
                  font-weight: 800 !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  box-shadow: none !important;
                  cursor: pointer !important;
                }

                .rt-action-btn:hover {
                  background: #f8fafc !important;
                  color: #0f172a !important;
                  border-color: #94a3b8 !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
                  text-decoration: none !important;
                }

                .rt-action-btn.primary {
                  background: #2563eb !important;
                  border-color: #2563eb !important;
                  color: #ffffff !important;
                }

                .rt-action-btn.primary:hover {
                  background: #1d4ed8 !important;
                  border-color: #1d4ed8 !important;
                  color: #ffffff !important;
                  box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
                }

                .wf-icon-calendar-start {
                  background: #ecfdf5 !important;
                  color: #059669 !important;
                }

                .wf-icon-calendar-end {
                  background: #fff1f2 !important;
                  color: #e11d48 !important;
                }

                /* ── Partner Card (Subcontractor / Recruiter) ─── */
                .wf-partner-card {
                  display: flex !important;
                  align-items: flex-start !important;
                  gap: 8px !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                }

                .wf-partner-column-stack {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 6px !important;
                  width: 100% !important;
                }

                .wf-partner-summary-card {
                  padding: 10px !important;
                  border: 1px solid #e2e8f0 !important;
                  border-radius: 8px !important;
                  background: #ffffff !important;
                  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04) !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                }

                .wf-partner-left {
                  display: flex !important;
                  flex-direction: column !important;
                  align-items: center !important;
                  gap: 4px !important;
                  flex-shrink: 0 !important;
                }

                .wf-partner-avatar {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 32px !important;
                  height: 32px !important;
                  border-radius: 8px !important;
                  background: linear-gradient(135deg, #ccfbf1 0%, #dbeafe 100%) !important;
                  color: #0f766e !important;
                  font-size: 12px !important;
                  font-weight: 700 !important;
                  letter-spacing: 0.5px !important;
                  flex: 0 0 auto !important;
                  box-shadow: 0 3px 6px rgba(15, 118, 110, 0.08) !important;
                  border: 2px solid #ffffff !important;
                  outline: 1px solid #dbeafe !important;
                }

                .wf-partner-avatar.is-recruiter {
                  background: linear-gradient(135deg, #ede9fe 0%, #e0f2fe 100%) !important;
                  color: #6d28d9 !important;
                  box-shadow: 0 3px 6px rgba(100, 116, 139, 0.06) !important;
                  outline-color: #cbd5e1 !important;
                }

                .wf-partner-avatar.is-candidate {
                  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
                  color: #2563eb !important;
                  box-shadow: 0 3px 6px rgba(37, 99, 235, 0.08) !important;
                  outline-color: #bfdbfe !important;
                }

                .wf-partner-avatar.is-inactive {
                  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
                  color: #64748b !important;
                  box-shadow: 0 3px 6px rgba(100, 116, 139, 0.06) !important;
                  outline-color: #cbd5e1 !important;
                }

                .wf-partner-avatar-id {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  font-size: 9px !important;
                  font-weight: 700 !important;
                  color: #475569 !important;
                  background: #f1f5f9 !important;
                  border: 1px solid #e2e8f0 !important;
                  border-radius: 20px !important;
                  padding: 0px 6px !important;
                  white-space: nowrap !important;
                  letter-spacing: 0.2px !important;
                }

                .wf-agency-avatar {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 32px !important;
                  height: 32px !important;
                  border-radius: 8px !important;
                  background: linear-gradient(135deg, #fef3c7 0%, #dbeafe 100%) !important;
                  color: #b45309 !important;
                  border: 2px solid #ffffff !important;
                  outline: 1px solid #fde68a !important;
                  box-shadow: 0 3px 6px rgba(180, 83, 9, 0.06) !important;
                  flex: 0 0 auto !important;
                  font-size: 12px !important;
                }

                .wf-metric-avatar {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 32px !important;
                  height: 32px !important;
                  border-radius: 8px !important;
                  border: 2px solid #ffffff !important;
                  flex: 0 0 auto !important;
                  font-size: 12px !important;
                }

                .wf-metric-avatar.is-duration {
                  background: linear-gradient(135deg, #e0f2fe 0%, #ede9fe 100%) !important;
                  color: #0369a1 !important;
                  outline: 1px solid #bae6fd !important;
                  box-shadow: 0 3px 6px rgba(3, 105, 161, 0.06) !important;
                }

                .wf-metric-avatar.is-msp {
                  background: linear-gradient(135deg, #fef3c7 0%, #ffedd5 100%) !important;
                  color: #b45309 !important;
                  outline: 1px solid #fde68a !important;
                  box-shadow: 0 3px 6px rgba(180, 83, 9, 0.06) !important;
                }

                .wf-partner-body {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 4px !important;
                  min-width: 0 !important;
                  flex: 1 !important;
                }

                .wf-partner-name {
                  font-size: 11px !important;
                  font-weight: 800 !important;
                  color: #0f172a !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.3px !important;
                  line-height: 1.2 !important;
                  word-break: break-word !important;
                }

                .wf-partner-name-row {
                  display: flex !important;
                  align-items: flex-start !important;
                  gap: 6px !important;
                  min-width: 0 !important;
                }

                .wf-partner-status-icon {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 18px !important;
                  height: 18px !important;
                  border-radius: 999px !important;
                  flex: 0 0 auto !important;
                  font-size: 10px !important;
                  margin-top: -1px !important;
                }

                .wf-partner-status-icon.is-active {
                  background: #ecfdf5 !important;
                  border: 1px solid #a7f3d0 !important;
                  color: #047857 !important;
                }

                .wf-partner-status-icon.is-inactive {
                  background: #fef2f2 !important;
                  border: 1px solid #fecaca !important;
                  color: #dc2626 !important;
                }

                .wf-partner-info-row {
                  display: flex !important;
                  align-items: flex-start !important;
                  gap: 6px !important;
                  font-size: 11px !important;
                  color: #475569 !important;
                  line-height: 1.35 !important;
                  word-break: normal !important;
                  overflow-wrap: anywhere !important;
                }

                .wf-partner-info-row i {
                  font-size: 11px !important;
                  flex-shrink: 0 !important;
                }

                .wf-entity-action-bar {
                  background: #ffffff !important;
                  border: 1px solid #eef2f6 !important;
                  border-radius: 8px !important;
                  padding: 6px 8px !important;
                  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
                  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 4px !important;
                  margin-top: 6px !important;
                  width: 100% !important;
                  box-sizing: border-box !important;
                }

                .wf-entity-action-bar-row {
                  display: grid !important;
                  grid-template-columns: repeat(2, 1fr) !important;
                  gap: 6px !important;
                  width: 100% !important;
                }

                .wf-entity-action-bar .wf-tool-btn {
                  width: 100% !important;
                  justify-content: center !important;
                  padding: 7px 8px !important;
                  font-size: 11px !important;
                  gap: 5px !important;
                  box-sizing: border-box !important;
                  overflow: hidden !important;
                  text-overflow: ellipsis !important;
                  white-space: nowrap !important;
                }

                .wf-entity-action-bar:hover {
                  border-color: #cbd5e1 !important;
                  box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
                  transform: translateY(-1px) !important;
                }

                .wf-tool-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 5px !important;
                  border: 1px solid #dbe3ef !important;
                  border-radius: 8px !important;
                  background: #f8fafc !important;
                  color: #334155 !important;
                  font-size: 11px !important;
                  font-weight: 800 !important;
                  padding: 7px 10px !important;
                  transition: all 0.18s ease !important;
                  cursor: pointer !important;
                  white-space: nowrap !important;
                }

                .wf-tool-btn:hover {
                  background: #eff6ff !important;
                  border-color: #bfdbfe !important;
                  color: #1d4ed8 !important;
                  transform: translateY(-1px) !important;
                }

                .wf-entity-badge-row {
                  display: flex !important;
                  align-items: center !important;
                  flex-wrap: wrap !important;
                  gap: 6px !important;
                  margin-top: 4px !important;
                }

                .wf-entity-badge {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 5px !important;
                  padding: 3px 8px !important;
                  border-radius: 6px !important;
                  font-size: 10px !important;
                  font-weight: 800 !important;
                  letter-spacing: 0.3px !important;
                  text-transform: uppercase !important;
                  border: 1px solid transparent !important;
                }

                .wf-entity-badge.basis-c2c {
                  background: #eff6ff !important;
                  border-color: #bfdbfe !important;
                  color: #1e40af !important;
                }

                .wf-entity-badge.basis-1099 {
                  background: #faf5ff !important;
                  border-color: #e9d5ff !important;
                  color: #6b21a8 !important;
                }

                .wf-entity-badge.basis-w2 {
                  background: #ecfdf5 !important;
                  border-color: #a7f3d0 !important;
                  color: #065f46 !important;
                }

                .rt-summary-grid-wrapper {
                  animation: rtSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
                  width: 100%;
                }

                .rt-stat-card.is-large-card {
                  flex: 2 1 490px;
                }
                .rt-stat-card.is-small-card {
                  flex: 1 1 285px;
                }
                .rt-stat-card.is-empty-card {
                  flex: 0 0 150px !important;
                  min-width: 150px !important;
                }

                .rt-stat-card {
                  display: flex;
                  align-items: flex-start;
                  gap: 8px;
                  min-width: 0;
                  height: auto;
                  padding: 10px;
                  border: 1px solid #e2e8f0;
                  border-radius: 8px;
                  background: #ffffff;
                  box-shadow: 0 2px 8px rgba(15,23,42,0.035);
                  position: relative;
                  overflow: hidden;
                  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
                  width: 100%;
                  box-sizing: border-box;
                }

                .rt-stat-card::before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: 0;
                  bottom: 0;
                  width: 3px;
                  background: #dbeafe;
                }

                .rt-stat-card:hover {
                  border-color: #cbd5e1;
                  box-shadow: 0 8px 20px rgba(15,23,42,0.06);
                  transform: translateY(-1px);
                }

                .rt-stat-icon {
                  width: 28px;
                  height: 28px;
                  border-radius: 6px;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  flex: 0 0 28px;
                  background: var(--c-indigo-s);
                  color: var(--c-indigo);
                  font-size: 12px;
                }
                .rt-stat-icon.is-green { background: var(--c-green-s); color: var(--c-green); }
                .rt-stat-icon.is-amber { background: var(--c-amber-s); color: var(--c-amber); }
                .rt-stat-icon.is-rose { background: var(--c-rose-s); color: var(--c-rose); }
                .rt-stat-icon.is-sky { background: var(--c-sky-s); color: var(--c-sky); }

                .rt-stat-label {
                  display: inline-flex;
                  align-items: center;
                  gap: 6px;
                  color: #64748b;
                  font-size: 9px;
                  font-weight: 900;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  margin-bottom: 4px;
                }

                .rt-stat-value {
                  display: block;
                  color: var(--c-text);
                  font-size: 11px !important;
                  font-weight: 850;
                  line-height: 1.25;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .wf-identity-meta-row {
                  display: flex;
                  align-items: flex-start;
                  gap: 8px;
                  margin-top: 5px;
                  color: #475569;
                  font-size: 11px;
                }

                .wf-identity-meta-icon {
                  width: 18px;
                  height: 18px;
                  border-radius: 5px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  margin-top: 1px;
                }

                .wf-identity-meta-icon i {
                  font-size: 10px !important;
                  color: inherit !important;
                }

                .wf-icon-email {
                  background: #eff6ff;
                  color: #2563eb;
                }
                .wf-icon-phone {
                  background: #fff7ed;
                  color: #ea580c;
                }
                .wf-icon-calendar {
                  background: #faf5ff;
                  color: #7c3aed;
                }
                .wf-icon-address {
                  background: #fff1f2;
                  color: #e11d48;
                }
                .wf-icon-candidate {
                  background: #eff6ff;
                  color: #2563eb;
                }
                .wf-icon-building {
                  background: #f0fdfa;
                  color: #0f766e;
                }
                .wf-icon-recruiter {
                  background: #f5f3ff;
                  color: #7c3aed;
                }
                .wf-icon-percent {
                  background: #fef3c7;
                  color: #b45309;
                }
                .wf-icon-client {
                  background: #eef2ff;
                  color: #4f46e5;
                }
                .wf-icon-money {
                  background: #f0fdf4;
                  color: #16a34a;
                }

                .modal-backdrop {
                  z-index: 1080 !important;
                }
                .modal {
                  z-index: 1090 !important;
                  overflow-y: hidden !important;
                }

                /* Glassmorphic backdrop filter and blur */
                .modal-backdrop.show {
                  backdrop-filter: blur(8px) !important;
                  -webkit-backdrop-filter: blur(8px) !important;
                  background-color: rgba(15, 23, 42, 0.45) !important;
                  opacity: 1 !important;
                }

                /* Spring-like transition for scale-in animation */
                .modal.fade .rt-summary-modal.modal-dialog {
                  transform: scale(0.95) !important;
                  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
                }
                .modal.show .rt-summary-modal.modal-dialog {
                  transform: scale(1) !important;
                }

                .rt-summary-modal {
                  --task-accent: #64748b;
                  --task-soft: #f8fafc;
                  max-width: 90% !important;
                  width: 1200px !important;
                }
                .rt-summary-modal.theme-primary { --task-accent: #3b82f6; --task-soft: #eff6ff; }
                .rt-summary-modal.theme-info { --task-accent: #06b6d4; --task-soft: #ecfeff; }
                .rt-summary-modal.theme-warning { --task-accent: #f59e0b; --task-soft: #fffbeb; }
                .rt-summary-modal.theme-success { --task-accent: #22c55e; --task-soft: #f0fdf4; }
                .rt-summary-modal.theme-wf2-default { --task-accent: #eab308; --task-soft: #fef9c3; }
                .rt-summary-modal.theme-wf3-default { --task-accent: #10b981; --task-soft: #ecfdf5; }
                .rt-summary-modal.theme-wf4-default { --task-accent: #ef4444; --task-soft: #fef2f2; }
                .rt-summary-modal.theme-wf5-default { --task-accent: #f97316; --task-soft: #fff7ed; }
                .rt-summary-modal.theme-wf6-default { --task-accent: #8b5cf6; --task-soft: #f5f3ff; }
                .rt-summary-modal.theme-default,
                .rt-summary-modal.theme-wf-default { --task-accent: #64748b; --task-soft: #f8fafc; }

                .rt-summary-modal .modal-content {
                  border-radius: 12px !important;
                  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                  overflow: hidden !important;
                  background: #ffffff !important;
                }
                .rt-summary-modal .modal-header {
                  position: relative !important;
                  display: block !important;
                  padding: 24px 28px 20px 32px !important;
                  background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
                  border-bottom: 1px solid #edf2f7 !important;
                  overflow: hidden !important;
                  align-items: center;
                }
                .rt-summary-modal .modal-header::before {
                  content: "" !important;
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                  bottom: 0 !important;
                  width: 4px !important;
                  background: var(--task-accent) !important;
                }
                .rt-summary-modal .rt-header-shell {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 14px !important;
                  width: 100% !important;
                }
                .rt-summary-modal .rt-header-top {
                  display: flex !important;
                  justify-content: space-between !important;
                  align-items: flex-start !important;
                  gap: 18px !important;
                  width: 100% !important;
                }
                .rt-summary-modal .rt-header-main {
                  display: flex !important;
                  align-items: center !important;
                  gap: 14px !important;
                  min-width: 0 !important;
                  flex: 1 1 auto !important;
                }
                .rt-summary-modal .rt-header-copy {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 8px !important;
                  min-width: 0 !important;
                  padding-top: 4px !important;
                }
                .rt-summary-modal .rt-modal-title {
                  display: inline-flex !important;
                  align-items: center !important;
                  margin: 0 !important;
                  color: #0f172a !important;
                  font-size: 18px !important;
                  font-weight: 850 !important;
                  line-height: 1.2 !important;
                  min-width: 0 !important;
                }
                .rt-summary-modal .rt-header-icon {
                  width: 52px !important;
                  height: 52px !important;
                  min-height: 52px !important;
                  border-radius: 10px !important;
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  color: var(--task-accent) !important;
                  background: #ffffff !important;
                  border: 1px solid var(--task-accent) !important;
                  box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
                  font-size: 15px !important;
                  flex-shrink: 0 !important;
                }
                .rt-summary-modal .rt-modal-title-text {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 12px !important;
                  min-width: 0 !important;
                  flex-wrap: wrap !important;
                }
                .rt-summary-modal .rt-modal-title-badge {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  padding: 4px 10px !important;
                  border-radius: 999px !important;
                  font-size: 10px !important;
                  font-weight: 800 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.02em !important;
                  background: var(--task-soft) !important;
                  color: var(--task-accent) !important;
                  border: 1px solid #e2e8f0 !important;
                }
                .rt-summary-modal .rt-modal-meta-row {
                  display: flex !important;
                  align-items: center !important;
                  flex-wrap: wrap !important;
                  gap: 10px 12px !important;
                  margin-top: 0 !important;
                  padding-left: 0 !important;
                  font-size: 12px !important;
                  color: #64748b !important;
                }
                .rt-summary-modal .rt-meta-chip {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  background: #ffffff !important;
                  padding: 5px 10px !important;
                  border-radius: 8px !important;
                  font-weight: 700 !important;
                  color: #475569 !important;
                  border: 1px solid #e2e8f0 !important;
                  box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
                }
                .rt-summary-modal .rt-meta-chip i {
                  color: var(--task-accent) !important;
                  font-size: 11px !important;
                }
                .rt-summary-modal .rt-meta-divider {
                  width: 1px !important;
                  height: 16px !important;
                  background: #cbd5e1 !important;
                  margin: 0 4px !important;
                }
                .rt-summary-modal .rt-meta-desc {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  color: #64748b !important;
                  font-weight: 500 !important;
                  line-height: 1.4 !important;
                  font-size: 13px !important;
                }
                .rt-summary-modal .rt-meta-desc i {
                  color: var(--task-accent) !important;
                }
                .rt-summary-modal .wf-modal-footer-close-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 7px !important;
                  padding: 9px 20px !important;
                  font-size: 13px !important;
                  font-weight: 700 !important;
                  color: #475569 !important;
                  background: #ffffff !important;
                  border: 1px solid #cbd5e1 !important;
                  border-radius: 8px !important;
                  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
                  outline: none !important;
                  cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }
                .rt-summary-modal .wf-modal-footer-close-btn:hover {
                  background: #f8fafc !important;
                  color: #0f172a !important;
                  border-color: #94a3b8 !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
                }
                .rt-summary-modal .wf-modal-footer-close-btn i {
                  font-size: 11px !important;
                  color: #94a3b8 !important;
                }
                .rt-summary-modal .wf-modal-footer-close-btn:hover i {
                  color: #ef4444 !important;
                }
                .rt-summary-modal .modal-body {
                  max-height: calc(100vh - 250px) !important;
                  overflow-y: auto !important;
                  background: #ffffff !important;
                  padding: 24px !important;
                }
                .rt-summary-modal .modal-body::-webkit-scrollbar {
                  width: 6px !important;
                  height: 6px !important;
                }
                .rt-summary-modal .modal-body::-webkit-scrollbar-track {
                  background: transparent !important;
                }
                .rt-summary-modal .modal-body::-webkit-scrollbar-thumb {
                  background: #cbd5e1 !important;
                  border-radius: 4px !important;
                }
                .rt-summary-modal .modal-body::-webkit-scrollbar-thumb:hover {
                  background: #94a3b8 !important;
                }

                /* Premium Modal Footer Close Button */
                .rt-summary-modal .modal-footer {
                  background: #f8fafc !important;
                  border-top: 1px solid #edf2f7 !important;
                  padding: 16px 24px !important;
                  display: flex !important;
                  justify-content: flex-end !important;
                }

                /* Premium Header Close Button */
                .rt-summary-modal .rt-action-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 40px !important;
                  height: 40px !important;
                  padding: 0 !important;
                  font-size: 12px !important;
                  font-weight: 700 !important;
                  color: #64748b !important;
                  background: #ffffff !important;
                  border: 1px solid #cbd5e1 !important;
                  border-radius: 8px !important;
                  cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
                  outline: none !important;
                }
                .rt-summary-modal .rt-action-btn:hover {
                  color: #0f172a !important;
                  border-color: #94a3b8 !important;
                  background: #f8fafc !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
                }
                .rt-summary-modal .rt-action-btn:active {
                  transform: translateY(0) !important;
                }
                .rt-summary-modal .rt-action-btn i {
                  font-size: 11px !important;
                  color: #94a3b8 !important;
                  transition: color 0.2s ease !important;
                }
                .rt-summary-modal .rt-action-btn:hover i {
                  color: #ef4444 !important;
                }

                .rt-summary-popup-body .rt-panel,
                .rt-summary-popup-body .aed-container,
                .rt-summary-popup-body .aer-container {
                  margin-bottom: 0 !important;
                }
            `}</style>

      <div className="rt-page mb-3">
        <div className="rt-shell mb-3">
          <div className="rt-hero">
            <div className="rt-hero-left">
              <div className="rt-hero-icon">
                {heroInitials}
                <span className="rt-hero-icon-badge">
                  <i className="fa fa-user" aria-hidden="true" />
                </span>
              </div>
              <div className="rt-hero-main">
                <div className="rt-kicker">
                  <i className="fa fa-id-card-o" aria-hidden="true" />
                  Candidate Time Log Management
                </div>
                <h1 className="rt-title">{reviewSubject}</h1>
                <p className="rt-subtitle">
                  Review and manage onboarding workflow tasks for{" "}
                  {reviewSubject}.
                </p>
                <div className="rt-hero-highlights">
                  {item?.performerid && (
                    <div className="rt-hero-highlight" style={{ background: "#f1f5f9", borderColor: "#e2e8f0" }}>
                      <span style={{ fontWeight: "700", color: "#475569", marginRight: "4px" }}>CID:</span>
                      #{item.performerid}
                    </div>
                  )}
                  {item?.maxloans && (
                    <div className="rt-hero-highlight" style={{ background: "#ecfdf5", borderColor: "#bbf7d0", color: "#047857" }}>
                      <span style={{ fontWeight: "700", color: "#047857", marginRight: "4px" }}>IPCS:</span>
                      #{item.maxloans}
                    </div>
                  )}
                  {summaryHeaderEmail && (
                    <div className="rt-hero-highlight">
                      <i className="fa fa-envelope-o" />
                      {summaryHeaderEmail}
                    </div>
                  )}
                  {summaryHeaderPhone && (
                    <div className="rt-hero-highlight">
                      <i className="fa fa-phone" />
                      {formatUSPhoneNumber(summaryHeaderPhone)}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="rt-actions">
              <div className="rt-app-card">
                <div className="rt-app-card-left">
                  <div className="rt-app-card-icon">
                    <i className="fa fa-file-text-o" />
                  </div>
                  <div className="rt-app-card-info">
                    <span className="rt-app-card-label">
                      Application Status
                    </span>
                    <span className="rt-app-card-title">{displayAppName}</span>
                    <div className="rt-app-card-meta">
                      <span className="rt-app-card-ciid"># {displayCiid}</span>
                      <span
                        className={`rt-pill ${onboardingStatus === "Complete" ? "success" : "warning"}`}
                      >
                        <i
                          className={`fa ${onboardingStatus === "Complete" ? "fa-check-circle" : "fa-clock-o"}`}
                        />
                        {onboardingStatus}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rt-panel btn-default">
          <div className="rt-panel-header">
            <h2 className="rt-panel-title">
              <i className="fa fa-id-card-o" aria-hidden="true" />
              Summary Details
              <span className="rt-panel-title-badge">{reviewSubject}</span>
            </h2>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {type === "candetails" && (
                <button
                  type="button"
                  className="rt-action-btn"
                  onClick={() => {
                    const state = location.state;
                    if (state?.from === "/ReviewTask") {
                      navigate("/ReviewTask", { state: state?.reviewTaskState });
                    } else if (listType) {
                      navigate(`/ListCondidate/${listType}`, {
                        state: {
                          restoreCandidateList: true,
                          candidateListState,
                        },
                      });
                    } else {
                      window.history.back();
                    }
                  }}
                  style={{
                    color: "#2563eb",
                    borderColor: "rgba(37, 99, 235, 0.2)",
                  }}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true" />
                  Back
                </button>
              )}
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => setShowSummaryGrid(!showSummaryGrid)}
              >
                <i
                  className={`fa ${showSummaryGrid ? "fa-eye-slash" : "fa-eye"}`}
                  aria-hidden="true"
                />
                {showSummaryGrid ? "Hide Details" : "Show Details"}
              </button>
            </div>
          </div>
          {showSummaryGrid && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                width: "100%",
                alignItems: "stretch",
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
              }}
            >
              {/* Card 1: Candidate */}
              <div className="rt-stat-card is-small-card">
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Candidate</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div
                        className="wf-partner-left"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <div className="wf-partner-avatar is-candidate">
                          {(reviewSubject || "")
                            .split(" ")
                            .filter(Boolean)
                            .slice(0, 2)
                            .map((w) => w[0])
                            .join("")
                            .toUpperCase() || "CN"}
                        </div>
                        {item?.performerid && (
                          <span className="wf-partner-avatar-id">
                            #{item.performerid}
                          </span>
                        )}
                      </div>
                      <div
                        className="wf-partner-body"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <button
                          onClick={() =>
                            handleViewcandidateForm("Candidate", 0, item)
                          }
                          className="btn p-0 btn-link btn-sm text-uppercase text-left font-weight-bold"
                          style={{
                            color: "#0f172a",
                            fontSize: "11px",
                            letterSpacing: "0.3px",
                          }}
                        >
                          {reviewSubject}
                        </button>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                            marginTop: "5px",
                          }}
                        >
                          {item?.performeremail && (
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-email"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#eff6ff",
                                  color: "#2563eb",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-envelope-o" />
                              </div>
                              <span
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.performeremail}
                              </span>
                            </div>
                          )}
                          {item?.contactNo && (
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-phone"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#fff7ed",
                                  color: "#ea580c",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-phone" />
                              </div>
                              <span>{formatUSPhoneNumber(item.contactNo)}</span>
                            </div>
                          )}
                          {item?.addedDateTime && (
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-calendar"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#fef2f2",
                                  color: "#ef4444",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-calendar-o" />
                              </div>
                              <span>
                                Joined:{" "}
                                <Moment format="MMM D, YYYY">
                                  {item.addedDateTime}
                                </Moment>
                              </span>
                            </div>
                          )}
                          {candidateAddress && (
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-address"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f5f5f4",
                                  color: "#78716c",
                                  fontSize: "9px",
                                  flexShrink: 0,
                                }}
                              >
                                <i className="fa fa-map-marker" />
                              </div>
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  minWidth: 0,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {[
                                  candidateAddress.line1,
                                  candidateAddress.line2,
                                ]
                                  .filter(Boolean)
                                  .join(", ") && (
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {[
                                      candidateAddress.line1,
                                      candidateAddress.line2,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </span>
                                )}
                                {[
                                  candidateAddress.city,
                                  candidateAddress.state,
                                  candidateAddress.zip,
                                ]
                                  .filter(Boolean)
                                  .join(", ") && (
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {[
                                      candidateAddress.city,
                                      candidateAddress.state,
                                      candidateAddress.zip,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </span>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 2: Position & Entity */}
              <div className="rt-stat-card is-small-card">
                <div className="rt-stat-icon">
                  <i className="fa fa-briefcase" aria-hidden="true" />
                </div>
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Position & Entity</span>
                  {getProjectField("PositionTitle") ? (
                    <span
                      className="rt-stat-value"
                      title={getProjectField("PositionTitle")}
                    >
                      {getProjectField("PositionTitle")}
                    </span>
                  ) : (
                    <span
                      className="wf-muted-text"
                      style={{
                        fontStyle: "italic",
                        fontSize: "12px",
                        color: "#94a3b8",
                      }}
                    >
                      No Position Title
                    </span>
                  )}

                  <div className="wf-entity-badge-row">
                    {getOnboardingField("CandidateEntity") ? (
                      <>
                        {getOnboardingField("CandidateEntity") ===
                          "C2C Basis" && (
                          <span className="wf-entity-badge basis-c2c">
                            <i className="fa fa-building-o" /> C2C
                          </span>
                        )}
                        {getOnboardingField("CandidateEntity") ===
                          "1099 Basis" && (
                          <span className="wf-entity-badge basis-1099">
                            <i className="fa fa-handshake-o" /> 1099
                          </span>
                        )}
                        {getOnboardingField("CandidateEntity") ===
                          "W2 Basis" && (
                          <span className="wf-entity-badge basis-w2">
                            <i className="fa fa-user-circle-o" /> W2{" "}
                            {getOnboardingField("w9_Type") &&
                              `(${getOnboardingField("w9_Type")})`}
                          </span>
                        )}
                      </>
                    ) : (
                      <span
                        style={{
                          color: "#94a3b8",
                          fontSize: "11px",
                          fontStyle: "italic",
                        }}
                      >
                        No Entity Type
                      </span>
                    )}
                  </div>

                  {item?.rates?.candidateRate ||
                  getOnboardingField("Per_Diem_Rate") ? (
                    <div
                      style={{
                        marginTop: "8px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      {item?.rates?.candidateRate ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: "12px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                            }}
                          >
                            <span
                              style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#f0fdf4",
                                color: "#16a34a",
                                fontSize: "9px",
                              }}
                            >
                              <i className="fa fa-money" />
                            </span>
                            Rate
                          </span>
                          <span style={{ fontWeight: "600", color: "#1e293b" }}>
                            <RateEncryptDecrypt
                              rateData={item.rates.candidateRate}
                            />
                          </span>
                        </div>
                      ) : null}
                      {getOnboardingField("Per_Diem_Rate") ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            fontSize: "12px",
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                            }}
                          >
                            <span
                              style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#fff1f2",
                                color: "#e11d48",
                                fontSize: "9px",
                              }}
                            >
                              <i className="fa fa-cutlery" />
                            </span>
                            Per Diem
                          </span>
                          <span style={{ fontWeight: "600", color: "#1e293b" }}>
                            <RateEncryptDecrypt
                              rateData={getOnboardingField("Per_Diem_Rate")}
                              endSymbol="/Day"
                            />
                          </span>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* Card 3: Agency & Client */}
              <div className="rt-stat-card is-small-card">
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Agency & Client</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div
                        className="wf-partner-left"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div className="wf-agency-avatar">
                          <i className="fa fa-handshake-o" />
                        </div>
                      </div>
                      <div
                        className="wf-partner-body"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {getProjectField("AgencyName") ? (
                          <span
                            className="wf-partner-name"
                            style={{
                              fontSize: "11px",
                              fontWeight: "800",
                              color: "#0f172a",
                              textTransform: "uppercase",
                            }}
                          >
                            {getProjectField("AgencyName")}
                          </span>
                        ) : (
                          <span
                            className="wf-partner-name"
                            style={{ color: "#94a3b8", fontStyle: "italic" }}
                          >
                            No Agency
                          </span>
                        )}

                        {getProjectValue([
                          "ClientName",
                          "Client_Name",
                          "EndClient",
                          "End_Client",
                          "Client",
                        ]) && (
                          <div
                            className="wf-partner-info-row"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              fontSize: "11px",
                              color: "#475569",
                            }}
                          >
                            <div
                              className="wf-identity-meta-icon wf-icon-client"
                              style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#eef2ff",
                                color: "#4f46e5",
                                fontSize: "9px",
                              }}
                            >
                              <i className="fa fa-briefcase" />
                            </div>
                            <span style={{ fontWeight: "500" }}>Client:</span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#334155",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {getProjectValue([
                                "ClientName",
                                "Client_Name",
                                "EndClient",
                                "End_Client",
                                "Client",
                              ])}
                            </span>
                          </div>
                        )}

                        <div
                          className="wf-partner-info-row"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "11px",
                            color: "#475569",
                          }}
                        >
                          <div
                            className="wf-identity-meta-icon wf-icon-money"
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f0fdf4",
                              color: "#16a34a",
                              fontSize: "9px",
                            }}
                          >
                            <i className="fa fa-money" />
                          </div>
                          <span style={{ fontWeight: "500" }}>Rate:</span>
                          <span style={{ fontWeight: "600", color: "#334155" }}>
                            {item?.rates?.agencyRate ? (
                              <RateEncryptDecrypt
                                rateData={item.rates.agencyRate}
                              />
                            ) : (
                              "$0.00/Hr"
                            )}
                          </span>
                        </div>

                        {getAdminAgencyFee() && (
                          <div
                            className="wf-partner-info-row"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              fontSize: "11px",
                              color: "#475569",
                            }}
                          >
                            <div
                              className="wf-identity-meta-icon wf-icon-percent"
                              style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#faf5ff",
                                color: "#7c3aed",
                                fontSize: "9px",
                              }}
                            >
                              <i className="fa fa-percent" />
                            </div>
                            <span
                              style={{ fontWeight: "600", color: "#334155" }}
                            >
                              {getAdminAgencyFee()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="wf-entity-action-bar">
                      <div className="wf-entity-action-bar-row">
                        {type !== "candetails" && (
                          <button
                            type="button"
                            className="wf-tool-btn is-docs"
                            onClick={() =>
                              handleDocumentViewShowHide("Candidate")
                            }
                            title="Contract Documents"
                          >
                            <i className="fa fa-file-text-o" />
                            Documents
                          </button>
                        )}
                        {type !== "candetails" &&
                          getFieldData(
                            item?.performerData,
                            "candidateonboardingform",
                            "CandidateEntity",
                          ) !== "C2C Basis" && (
                            <button
                              type="button"
                              className="wf-tool-btn is-ach"
                              onClick={() =>
                                handleACHShowHide(
                                  "ACH",
                                  "Candidate",
                                  item,
                                  1,
                                  app,
                                )
                              }
                              title="ACH Information"
                            >
                              <i className="fa fa-bank" />
                              ACH{" "}
                              {app?.achRequest > 0 && (
                                <span
                                  className="badge badge-pill badge-danger"
                                  style={{ marginLeft: "3px" }}
                                >
                                  {app.achRequest}
                                </span>
                              )}
                            </button>
                          )}
                      </div>
                      {getProjectField("AgencyName") && (
                        <div
                          className="wf-entity-action-bar-row"
                          style={{ marginTop: "4px" }}
                        >
                          <button
                            type="button"
                            className="wf-tool-btn is-docs"
                            onClick={() => handleDocumentViewShowHide("agency")}
                            title="Upload Agency/Client Document"
                          >
                            <i className="fa fa-upload" />
                            Agency Doc
                          </button>
                          <button
                            type="button"
                            className="wf-tool-btn is-form"
                            onClick={() => handleViewShowHide("agency")}
                            title="View Agency"
                          >
                            <i className="fa fa-eye" />
                            View Agency
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 4: Subcontractor */}
              <div
                className={`rt-stat-card is-small-card ${!(getOnboardingField("CandidateEntity") === "C2C Basis" && item?.subcontractor) ? "is-empty-card" : ""}`}
              >
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Subcontractor</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      {getOnboardingField("CandidateEntity") === "C2C Basis" &&
                      item?.subcontractor ? (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div
                              className={`wf-partner-avatar ${item.subcontractor.useFlag ? "" : "is-inactive"}`}
                            >
                              {(item.subcontractor?.label || "")
                                .split(" ")
                                .filter(Boolean)
                                .slice(0, 2)
                                .map((w) => w[0])
                                .join("")
                                .toUpperCase() || "SC"}
                            </div>
                            {item.subcontractor?.parentid && (
                              <span className="wf-partner-avatar-id">
                                #{item.subcontractor.parentid}
                              </span>
                            )}
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            <div
                              className="wf-partner-name-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span
                                className="wf-partner-name"
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "800",
                                  color: "#0f172a",
                                  textTransform: "uppercase",
                                }}
                              >
                                {item.subcontractor?.label}
                              </span>
                              <span
                                className={`wf-partner-status-icon ${item.subcontractor.useFlag ? "is-active" : "is-inactive"}`}
                                title={
                                  item.subcontractor.useFlag
                                    ? "Active subcontractor"
                                    : "Inactive subcontractor"
                                }
                              >
                                <i
                                  className={`fa ${item.subcontractor.useFlag ? "fa-check" : "fa-times"}`}
                                />
                              </span>
                            </div>
                            {item.subcontractor?.email && (
                              <div
                                className="wf-partner-info-row"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "11px",
                                  color: "#475569",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-email"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#eff6ff",
                                    color: "#2563eb",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.subcontractor.email}
                                </span>
                              </div>
                            )}
                            {getSubcontractorPhone() && (
                              <div
                                className="wf-partner-info-row"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "11px",
                                  color: "#475569",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-phone"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#fff7ed",
                                    color: "#ea580c",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-phone" />
                                </div>
                                <span>
                                  {getFormatedNumber(getSubcontractorPhone())}
                                </span>
                              </div>
                            )}
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-money"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f0fdf4",
                                  color: "#16a34a",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-money" />
                              </div>
                              <span style={{ fontWeight: "600" }}>
                                {item?.rates?.subcontractorRate ? (
                                  <RateEncryptDecrypt
                                    rateData={item.rates.subcontractorRate}
                                  />
                                ) : (
                                  "$0.00/Hr"
                                )}
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div className="wf-partner-avatar is-inactive">
                              SC
                            </div>
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                              justifyContent: "center",
                            }}
                          >
                            <span
                              className="wf-partner-name"
                              style={{ color: "#94a3b8", fontStyle: "italic" }}
                            >
                              Not Applicable
                            </span>
                          </div>
                        </>
                      )}
                    </div>

                    {getOnboardingField("CandidateEntity") === "C2C Basis" &&
                      item?.subcontractor && (
                        <div className="wf-entity-action-bar">
                          <div className="wf-entity-action-bar-row">
                            <button
                              type="button"
                              className="wf-tool-btn is-form"
                              onClick={() =>
                                handleViewcandidateForm(
                                  "Subcontractor",
                                  0,
                                  item,
                                )
                              }
                              title="Subcontractor Onboarding Form"
                            >
                              <i className="fa fa-list-alt" />
                              View Form
                            </button>
                            {type === "candetails" ? (
                              <button
                                className="wf-tool-btn is-po"
                                onClick={() =>
                                  handlePurchaseShowHide(
                                    item,
                                    "view",
                                    "Sub-Contractors",
                                  )
                                }
                                title="View Purchase Order"
                              >
                                <i className="fa fa-shopping-cart" />
                                View PO
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  handleDocumentViewShowHide("Subcontractor")
                                }
                                className="wf-tool-btn is-docs"
                                title="Send Documents"
                              >
                                <i className="fa fa-envelope-o" />
                                Send Docs
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              </div>

              {/* Card 5: Recruiter */}
              <div
                className={`rt-stat-card is-small-card ${!item?.recruiter ? "is-empty-card" : ""}`}
              >
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Recruiter</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      {item?.recruiter ? (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div
                              className={`wf-partner-avatar is-recruiter ${item.recruiter.useFlag ? "" : "is-inactive"}`}
                            >
                              {(item.recruiter?.label || "")
                                .split(" ")
                                .filter(Boolean)
                                .slice(0, 2)
                                .map((w) => w[0])
                                .join("")
                                .toUpperCase() || "RC"}
                            </div>
                            {item.recruiter?.fuid && (
                              <span className="wf-partner-avatar-id">
                                #{item.recruiter.fuid}
                              </span>
                            )}
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            <div
                              className="wf-partner-name-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span
                                className="wf-partner-name"
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "800",
                                  color: "#0f172a",
                                  textTransform: "uppercase",
                                }}
                              >
                                {item.recruiter?.label}
                              </span>
                              <span
                                className={`wf-partner-status-icon ${item.recruiter.useFlag ? "is-active" : "is-inactive"}`}
                                title={
                                  item.recruiter.useFlag
                                    ? "Active recruiter"
                                    : "Inactive recruiter"
                                }
                              >
                                <i
                                  className={`fa ${item.recruiter.useFlag ? "fa-check" : "fa-times"}`}
                                />
                              </span>
                            </div>
                            {item.recruiter?.email && (
                              <div
                                className="wf-partner-info-row"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "11px",
                                  color: "#475569",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-email"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#eff6ff",
                                    color: "#2563eb",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-envelope-o" />
                                </div>
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {item.recruiter.email}
                                </span>
                              </div>
                            )}
                            {getRecruiterPhone() && (
                              <div
                                className="wf-partner-info-row"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  fontSize: "11px",
                                  color: "#475569",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-phone"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#fff7ed",
                                    color: "#ea580c",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-phone" />
                                </div>
                                <span>
                                  {getFormatedNumber(getRecruiterPhone())}
                                </span>
                              </div>
                            )}
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-money"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#f0fdf4",
                                  color: "#16a34a",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-money" />
                              </div>
                              <span style={{ fontWeight: "600" }}>
                                {item?.rates?.recruiterRate ? (
                                  <RateEncryptDecrypt
                                    rateData={item.rates.recruiterRate}
                                  />
                                ) : (
                                  "$0.00/Hr"
                                )}
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <div className="wf-partner-avatar is-recruiter is-inactive">
                              RC
                            </div>
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                              justifyContent: "center",
                            }}
                          >
                            <span
                              className="wf-partner-name"
                              style={{ color: "#94a3b8", fontStyle: "italic" }}
                            >
                              Not Applicable
                            </span>
                          </div>
                        </>
                      )}
                    </div>

                    {item?.recruiter && (
                      <div className="wf-entity-action-bar">
                        <div className="wf-entity-action-bar-row">
                          <button
                            type="button"
                            className="wf-tool-btn is-form"
                            onClick={() =>
                              handleViewcandidateForm("Recruiter", 0, item)
                            }
                            title="Recruiter Onboarding Form"
                          >
                            <i className="fa fa-list-alt" />
                            View Form
                          </button>
                          {type === "candetails" ? (
                            <button
                              className="wf-tool-btn is-po"
                              onClick={() =>
                                handlePurchaseShowHide(
                                  item,
                                  "view",
                                  "Recruiter",
                                )
                              }
                              title="View Purchase Order"
                            >
                              <i className="fa fa-shopping-cart" />
                              View PO
                            </button>
                          ) : (
                            <button
                              onClick={() =>
                                handleDocumentViewShowHide("Recruiter")
                              }
                              className="wf-tool-btn is-docs"
                              title="Send Documents"
                            >
                              <i className="fa fa-envelope-o" />
                              Send Docs
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Card 6: MSP */}
              <div className="rt-stat-card is-small-card">
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">MSP</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      {getFieldData(
                        item?.performerData,
                        "candidateonboardingform",
                        "Msp_Mode",
                      ) ? (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="wf-metric-avatar is-msp"
                              style={{ margin: 0 }}
                            >
                              <i className="fa fa-sitemap" aria-hidden="true" />
                            </div>
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            <span
                              className="rt-stat-value"
                              title={
                                getFieldData(
                                  item?.performerData,
                                  "candidateonboardingform",
                                  "Msp_Mode",
                                ) === "Others"
                                  ? getFieldData(
                                      item?.performerData,
                                      "candidateonboardingform",
                                      "MSP_Other_Mode",
                                    )
                                  : getFieldData(
                                      item?.performerData,
                                      "candidateonboardingform",
                                      "Msp_Mode",
                                    )
                              }
                            >
                              {getFieldData(
                                item?.performerData,
                                "candidateonboardingform",
                                "Msp_Mode",
                              ) === "Others"
                                ? getFieldData(
                                    item?.performerData,
                                    "candidateonboardingform",
                                    "MSP_Other_Mode",
                                  )
                                : getFieldData(
                                    item?.performerData,
                                    "candidateonboardingform",
                                    "Msp_Mode",
                                  )}
                            </span>
                            <div
                              className="wf-partner-info-row"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontSize: "11px",
                                color: "#475569",
                              }}
                            >
                              <div
                                className="wf-identity-meta-icon wf-icon-percent"
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: "#fef3c7",
                                  color: "#b45309",
                                  fontSize: "9px",
                                }}
                              >
                                <i className="fa fa-percent" />
                              </div>
                              <span style={{ fontWeight: "500" }}>
                                Admin Fee:
                              </span>
                              <span
                                style={{ fontWeight: "600", color: "#334155" }}
                              >
                                {getFieldData(
                                  item?.performerData,
                                  "candidateonboardingform",
                                  "Msp_AdminFee",
                                ) ? (
                                  <RateEncryptDecrypt
                                    rateData={getFieldData(
                                      item.performerData,
                                      "candidateonboardingform",
                                      "Msp_AdminFee",
                                    )}
                                    startSymbol=""
                                    endSymbol="%"
                                  />
                                ) : (
                                  "0%"
                                )}
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="wf-partner-left"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              className="wf-metric-avatar is-msp is-inactive"
                              style={{ margin: 0 }}
                            >
                              <i className="fa fa-sitemap" aria-hidden="true" />
                            </div>
                          </div>
                          <div
                            className="wf-partner-body"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                              flex: 1,
                              minWidth: 0,
                              justifyContent: "center",
                            }}
                          >
                            <span
                              className="wf-partner-name"
                              style={{ color: "#94a3b8", fontStyle: "italic" }}
                            >
                              Not Applicable
                            </span>
                          </div>
                        </>
                      )}
                    </div>

                    {getFieldData(
                      item?.performerData,
                      "candidateonboardingform",
                      "Msp_Mode",
                    ) && (
                      <div className="wf-entity-action-bar">
                        <div className="wf-entity-action-bar-row">
                          <button
                            type="button"
                            className="wf-tool-btn is-form"
                            onClick={() => handleViewShowHide("msp")}
                            title="View MSP"
                          >
                            <i className="fa fa-eye" />
                            View MSP
                          </button>
                          {type !== "candetails" && (
                            <button
                              type="button"
                              className="wf-tool-btn is-docs"
                              onClick={() => handleDocumentViewShowHide("msp")}
                              title="Upload MSP Document"
                            >
                              <i className="fa fa-upload" />
                              Upload Doc
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Card 7: Tech & Hub Fee */}
              <div className="rt-stat-card is-small-card">
                <div
                  className="rt-stat-icon is-green"
                  style={{ alignSelf: "flex-start", marginTop: "2px" }}
                >
                  <i className="fa fa-calculator" aria-hidden="true" />
                </div>
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Tech & Hub Fee</span>

                  <div
                    style={{
                      marginTop: "6px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: "11px",
                        color: "#64748b",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <div
                          className="wf-identity-meta-icon wf-icon-candidate"
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "9px",
                          }}
                        >
                          <i className="fa fa-user-circle-o" />
                        </div>
                        Candidate:
                      </span>
                      <span style={{ fontWeight: "600", color: "#334155" }}>
                        {item?.rates?.candidateTechFee ? (
                          <RateEncryptDecrypt
                            rateData={item.rates.candidateTechFee}
                          />
                        ) : (
                          "$0.00/Hr"
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: "11px",
                        color: "#64748b",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginRight: "0.5rem",
                        }}
                      >
                        <div
                          className="wf-identity-meta-icon wf-icon-building"
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "9px",
                          }}
                        >
                          <i className="fa fa-building-o" />
                        </div>
                        Subcontractor:
                      </span>
                      <span style={{ fontWeight: "600", color: "#334155" }}>
                        {item?.rates?.subcontractorTechFee ? (
                          <RateEncryptDecrypt
                            rateData={item.rates.subcontractorTechFee}
                          />
                        ) : (
                          "$0.00/Hr"
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: "11px",
                        color: "#64748b",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <div
                          className="wf-identity-meta-icon wf-icon-recruiter"
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "9px",
                          }}
                        >
                          <i className="fa fa-users" />
                        </div>
                        Recruiter:
                      </span>
                      <span style={{ fontWeight: "600", color: "#334155" }}>
                        {item?.rates?.recruiterTechFee ? (
                          <RateEncryptDecrypt
                            rateData={item.rates.recruiterTechFee}
                          />
                        ) : (
                          "$0.00/Hr"
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontSize: "11px",
                        color: "#64748b",
                        borderTop: "1px dashed #e2e8f0",
                        paddingTop: "4px",
                        marginTop: "4px",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <div
                          className="wf-identity-meta-icon wf-icon-percent"
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "9px",
                          }}
                        >
                          <i className="fa fa-percent" />
                        </div>
                        Hub Fee:
                      </span>
                      <span style={{ fontWeight: "600", color: "#334155" }}>
                        {getFieldData(
                          item?.performerData,
                          "candidateonboardingform",
                          "Hub_CompanyFee",
                        ) ? (
                          <RateEncryptDecrypt
                            rateData={getFieldData(
                              item.performerData,
                              "candidateonboardingform",
                              "Hub_CompanyFee",
                            )}
                            startSymbol=""
                            endSymbol="%"
                          />
                        ) : (
                          "0%"
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 8: Duration */}
              <div className="rt-stat-card is-small-card">
                <div style={{ width: "100%" }}>
                  <span className="rt-stat-label">Duration</span>
                  <div
                    className="wf-partner-column-stack"
                    style={{ marginTop: "4px" }}
                  >
                    <div
                      className="wf-partner-card"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div
                        className="wf-partner-left"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div className="wf-metric-avatar is-duration">
                          <i className="fa fa-hourglass-half" />
                        </div>
                      </div>
                      <div
                        className="wf-partner-body"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        {item?.duration?.duration ? (
                          <>
                            <span
                              className="wf-entity-badge basis-c2c"
                              style={{
                                alignSelf: "flex-start",
                                marginBottom: "4px",
                              }}
                            >
                              <i className="fa fa-hourglass-half" />{" "}
                              {item.duration.duration} Months
                            </span>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "4px",
                                marginTop: "4px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  fontSize: "11px",
                                  color: "#64748b",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-calendar-start"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-calendar-plus-o" />
                                </div>
                                <span style={{ fontWeight: "500" }}>
                                  Start:
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#334155",
                                  }}
                                >
                                  <Moment format="MMM Do YYYY">
                                    {item.duration.startDate}
                                  </Moment>
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  fontSize: "11px",
                                  color: "#64748b",
                                }}
                              >
                                <div
                                  className="wf-identity-meta-icon wf-icon-calendar-end"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    borderRadius: "50%",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "9px",
                                  }}
                                >
                                  <i className="fa fa-calendar-times-o" />
                                </div>
                                <span style={{ fontWeight: "500" }}>End:</span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#334155",
                                  }}
                                >
                                  <Moment format="MMM Do YYYY">
                                    {item.duration.endDate}
                                  </Moment>
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <span
                            className="wf-partner-name"
                            style={{ color: "#94a3b8", fontStyle: "italic" }}
                          >
                            No Active Duration
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="wf-entity-action-bar">
                      <div className="wf-entity-action-bar-row">
                        <button
                          type="button"
                          className="wf-tool-btn is-form"
                          onClick={() =>
                            handleDurationAndRateShowHide(item, "duration", 0)
                          }
                          title="Edit Duration"
                        >
                          <i className="fa fa-calendar" />
                          Duration
                        </button>
                        <button
                          type="button"
                          className="wf-tool-btn is-ach"
                          onClick={() =>
                            handleDurationAndRateShowHide(item, "rate", 0)
                          }
                          title="Modify Rate"
                        >
                          <i className="fa fa-dollar" />
                          Rate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={isPopupOpen}
        onHide={handleClosePopup}
        size="xl"
        dialogClassName="rt-summary-modal theme-default"
        centered
      >
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i
                  className={`rt-header-icon fa ${getPopupIcon()}`}
                  aria-hidden="true"
                />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{getPopupTitle()}</span>
                    </span>
                  </h2>
                  {reviewSubject && (
                    <div className="rt-modal-meta-row">
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" aria-hidden="true" />{" "}
                        {reviewSubject}
                      </span>
                      {summaryHeaderEmail && (
                        <span
                          className="rt-meta-chip"
                          title={summaryHeaderEmail}
                        >
                          <i className="fa fa-envelope" aria-hidden="true" />{" "}
                          {summaryHeaderEmail}
                        </span>
                      )}
                      {summaryHeaderPhone && (
                        <span className="rt-meta-chip">
                          <i className="fa fa-phone" aria-hidden="true" />{" "}
                          {formatUSPhoneNumber(summaryHeaderPhone)}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleClosePopup}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="rt-summary-popup-body">
            {editDurType !== "" && fetchedDataType === "Document" && (
              <Document
                documents={appDocuments}
                workflowTask={selectedCurrentTask}
                uploadType={`${editDurType}`}
                app={app}
                item={item}
                pageModule={"review"}
                viewType={
                  editDurType === "Subcontractor" || editDurType === "Recruiter"
                    ? "candidateList"
                    : ""
                }
                type={type}
                embedded={true}
              />
            )}

            {selectedInfo === "ACH" && (
              <AchInformation
                workflowTask={selectedCurrentTask}
                app={selectedApp}
                item={item}
                setViewBprmFormShowHide={setViewBprmFormShowHide}
                viewType={"candidateList1"}
                achType={achType}
                setSelectedApp={setSelectedApp}
                onBack={handleClosePopup}
                hideHeader={true}
              />
            )}

            {selectedInfo === "Insurance" && (
              <InsuranseInformation
                workflowTask={selectedCurrentTask}
                app={selectedApp}
                item={item}
                setViewBprmFormShowHide={setViewBprmFormShowHide}
                viewType={"candidateList1"}
                insuranceType={insuranceType}
                setSelectedApp={setSelectedApp}
                onBack={handleClosePopup}
              />
            )}

            {viewType !== "" && viewShowHide && (
              <ViewCandidate
                handleDurationShowHide={handleDurationAndRateShowHide}
                heading={""}
                viewShowHide={viewShowHide}
                handleViewShowHide={handleViewShowHide}
                selectedObj={item}
                viewType={viewType}
                filterSubcontractorList={[]}
                filterRecruiterList={[]}
                onClose={handleClosePopup}
                hideHeader={true}
              />
            )}

            {wfForm && SelectedFormKey === 0 && (
              <WorkflowElement
                wfTask={wfTask}
                wfForm={wfForm}
                handleNextTask={handleNextTask}
                viewType={true}
                appSummary={false}
                codeVerified={true}
                wfTaskType={"form"}
                updatedStateData={updatedStateData}
              />
            )}

            {editDurType === "duration" && (
              <AddEditDuration
                handleDurationShowHide={handleDurationAndRateShowHide}
                selectedObj={candidate}
                editType={editDurType}
                hideHeader={true}
              />
            )}

            {editDurType === "rate" && (
              <AddEditRates
                handleDurationShowHide={handleDurationAndRateShowHide}
                selectedObj={candidate}
                editType={editDurType}
                hideHeader={true}
              />
            )}
            {purchaseShowHide && (
              <PurchaseOrderPopup
                purchaseShowHide={purchaseShowHide}
                handlePurchaseShowHide={handleClosePopup}
                candidateObj={candidateObj}
                workflowTask={selectedCurrentTask}
                poOrderType={poOrderType}
                item={selectedItem}
                handleSignUnsignPo={handleSignUnsignPo}
                handleRefreshPoOrders={handleRefreshPoOrders}
                renderType="generate"
                onBack={handleClosePopup}
                hideHeader={true}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleClosePopup}
          >
            <i className="fa fa-times" aria-hidden="true" /> Close
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
